import 'css-chunksrc/client/scenes/workloads/calendar/months/styles.scss';export default {
  "months": "_months_xvafa_1",
  "month": "_month_xvafa_1"
};